import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services';
import { of } from 'rxjs';

/**
 * Error interceptor
 * injectable
 */
@Injectable({ providedIn: 'root' })
/**
 * Error interceptor
 * @class ErrorInterceptor
 * @implements {HttpInterceptor}
 */
export class ErrorInterceptorService implements HttpInterceptor {
  /**
   * inject auth service
   * @type {AuthService}
   */
  private authService = inject(AuthService);

  /**
   * intercept method
   * @param {HttpRequest<any>} req - The request
   * @param {HttpHandler} next - The http handler
   * @returns The observable of the http event
   * @description
   * This interceptor catch the http errors
   * and if the error status is 401 or 403
   * or 0 and the url is not in the blacklist
   * then it logout the user
   * and if the error status is 0 and the url is in the whitelist
   * then it return a success response
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    return next.handle(req).pipe(catchError((err: HttpErrorResponse) => {
      const urls = [
        '/company/preloadPassword/import',
        '/company/preloadPassword/template',
        '/company/preloadPasswords',
        '/company/preloadPassword/export/all',
        '/company/preloadPassword/export',
        '/company/preloadPassword/images',

        '/company/credit-card/import',
        '/company/credit-card/import',
        '/company/credit-card/export',

        '/company/access-kit/import',
        '/company/access-kit/multiple',
        '/company/access-kit/export',
        '/company/access-kit-user/import',
        '/company/access-kit-user/import/password',
        '/company/access-kit-user/multiple',
        '/company/access-kit-user/export-all',
        '/company/access-kit/images',

        '/company/preloadUrl/import',
        '/company/preloadUrl/export/all',
        '/company/preloadUrl/images'
        ,
        '/company/users',
        '/company/user/template',
        '/company/user/export/all',
        '/company/active-directory/user',

        '/company/group/manage',
        '/company/group/manage/id',
        '/company/group/manage/id',

        '/company/logs/export',

        '/company/device-restriction/import'

      ];

      if (err.status === 0 && urls.find((url) => err.url.includes(url) && req.method !== 'GET')) {
        return of(new HttpResponse({ body: { success: 7 }, status: 200 }));
      }

      if ((err.status === 401 || err.status === 403 || err.status === 0)) {
        if (err.status === 0) {
          this.authService.logout(true);
        }
        if (err.error?.isSubscription) {
          this.authService.logout(true, false, err.error.isSubscription);
        } else if (!err.url.includes('manager/password/reset') && !err.url.includes('manager/password/email') && !err.url.includes('manager/login') && !err.url.includes('manager/logout') && !err.url.includes('a2f/validReset')) {
          this.authService.logout(true, err.error?.isIpRestricted);
        }
      }
      return throwError(err);
    }));
  }
}
